import { createFileRoute } from "@tanstack/react-router";
import Saint, { saintSchema } from "@/pages/Saint";
import { SITE_URL } from "@/components/schemaConstants";

const SAINT_URL = `${SITE_URL}/saint`;

export const Route = createFileRoute("/saint")({
  head: () => ({
    meta: [
      { title: "SAINT® TMS for Depression | Coral Springs, FL" },
      {
        name: "description",
        content:
          "5-day, fMRI-guided SAINT® TMS for treatment-resistant depression. Verified SAINT Provider in Coral Springs, FL serving Florida and out-of-state patients.",
      },
      {
        property: "og:title",
        content: "SAINT® TMS for Depression | Coral Springs, FL",
      },
      {
        property: "og:description",
        content:
          "5-day, fMRI-guided SAINT® TMS for treatment-resistant depression. Verified SAINT Provider in Coral Springs, FL.",
      },
      { property: "og:url", content: SAINT_URL },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: SAINT_URL },
      { rel: "alternate", hrefLang: "en", href: SAINT_URL },
      { rel: "alternate", hrefLang: "es", href: `${SITE_URL}/es/saint` },
      { rel: "alternate", hrefLang: "x-default", href: SAINT_URL },
    ],
    scripts: saintSchema.map((graph) => ({
      type: "application/ld+json",
      children: JSON.stringify(graph),
    })),
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <Saint />;
}
